module.exports = __webpack_public_path__ + "img/goods14_5.867a8e01.jpg";